import React from "react"
import { withStyles, WithStyles, createStyles, Theme } from "@material-ui/core"
import { flexBreakpoint } from "./styles"
import { PostPreview } from "../../types/Post"
import Item from "./Item"

const styles = ({ breakpoints: { up } }: Theme) => {
  return createStyles({
    root: {
      margin: 0,
      padding: 0,
      [up(flexBreakpoint)]: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles> {
  posts: PostPreview[]
}

const Posts = ({ classes, posts }: Props) => {
  const renderItem = (post: PostPreview, index: number): JSX.Element => {
    return (
      <Item {...post} key={post.id} index={index} postsAmount={posts.length} />
    )
  }

  const renderedPosts: JSX.Element[] = posts.map(renderItem)

  return <ul className={classes.root}>{renderedPosts}</ul>
}

export default withStyles(styles)(Posts)
